import React from "react";
import { circle, number, item, awaitingItem } from "./item.styles";
import { motion, AnimatePresence } from "framer-motion";
import { colors, Body } from "../../";
import { jsx as ___EmotionJSX } from "@emotion/core";

var getItemProgress = function getItemProgress(activeStep, index) {
  return {
    completed: activeStep > index + 1,
    active: activeStep === index + 1
  };
};

var checkVariants = {
  hidden: {
    opacity: 0,
    transition: {
      delay: 0.3
    }
  },
  visible: {
    opacity: 1
  }
};

var Check = function Check(_ref) {
  var status = _ref.status;
  return ___EmotionJSX(AnimatePresence, null, ___EmotionJSX("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "translateX(-1px)"
    },
    width: "16",
    height: "16"
  }, ___EmotionJSX(motion.path, {
    initial: "hidden",
    animate: status,
    variants: checkVariants,
    exit: "hidden",
    fill: "white",
    d: "M7.632 9.574l4.672-5.199a.935.935 0 1 1 1.392 1.25l-5.392 6a.935.935 0 0 1-1.412-.024L4.284 8.493a.935.935 0 1 1 1.432-1.202l1.916 2.283z"
  })));
};

export var Item = function Item(_ref2) {
  var children = _ref2.children,
      _ref2$index = _ref2.index,
      index = _ref2$index === void 0 ? 0 : _ref2$index,
      _ref2$activeStep = _ref2.activeStep,
      activeStep = _ref2$activeStep === void 0 ? 0 : _ref2$activeStep;

  var _getItemProgress = getItemProgress(activeStep, index),
      active = _getItemProgress.active,
      completed = _getItemProgress.completed;

  var itemStyle = [item];
  var numberStyle = [circle, number];

  if (!active) {
    itemStyle.push(awaitingItem);
  }

  var itemVariants = {
    hidden: {
      opacity: 0,
      color: colors.gray[10]
    },
    completed: {
      opacity: 1,
      color: colors.gray[10]
    },
    active: {
      opacity: 1,
      color: colors.gray[10],
      transition: {
        delay: 0.1
      }
    },
    awaiting: {
      color: colors.gray[30],
      opacity: 1
    }
  };
  var numberVariants = {
    hidden: {
      opacity: 0,
      borderColor: colors.gray[50],
      backgroundColor: colors.white,
      color: colors.gray[30]
    },
    completed: {
      opacity: 1,
      borderColor: colors.blue[10],
      backgroundColor: colors.blue[10]
    },
    active: {
      opacity: 1,
      borderColor: colors.blue[10],
      backgroundColor: colors.white,
      color: colors.blue[10],
      transition: {
        when: "beforeChildren",
        delay: 0.1
      }
    },
    awaiting: {
      opacity: 1,
      borderColor: colors.gray[50],
      backgroundColor: colors.white,
      color: colors.gray[30]
    }
  };
  return ___EmotionJSX(motion.li, {
    initial: "hidden",
    animate: active ? "active" : completed ? "completed" : "awaiting",
    variants: itemVariants,
    transition: {
      duration: 0.2
    },
    css: itemStyle,
    "aria-current": active ? "true" : "false"
  }, ___EmotionJSX(motion.span, {
    variants: numberVariants,
    css: numberStyle
  }, completed ? ___EmotionJSX(Check, {
    status: completed ? "visible" : "hidden"
  }) : index + 1), ___EmotionJSX(Body, {
    renderAs: "span",
    weight: active ? "bold" : "medium"
  }, children));
};